var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 162 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 16.2083V128.792H18V16.2083H144ZM144 0.125H18C8.1 0.125 0 7.3625 0 16.2083V128.792C0 137.638 8.1 144.875 18 144.875H144C153.9 144.875 162 137.638 162 128.792V16.2083C162 7.3625 153.9 0.125 144 0.125ZM100.26 71.3742L73.26 102.495L54 81.6675L27 112.708H135L100.26 71.3742Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoImage);
export default __webpack_public_path__ + "static/media/icon_no-image.5393ecf2452abb10db9375bb2aafccd0.svg";
export { ForwardRef as ReactComponent };